import { Injectable } from '@angular/core';
import { CaseTypeEntity } from '../../domain/entities/case-type.entity';
import { CaseTypeDetailEntity } from '../../domain/entities/case-type-detail.entity';
import { CaseTypeCategoryEntity } from '../../domain/entities/case-type-category.entity';
import {
  CaseTypeDeletionImpactEntity,
  LinkedCaseEntity,
  LinkedCaseFormEntity,
  LinkedEmailTemplateEntity,
  LinkedProcessChecklistEntity,
} from '../../domain/entities/case-type-deletion-impact.entity';
import { ClosedCaseVisibility } from '../../domain/enums/closed-case-visibility.enum';
import { CaseTypeResponseDto } from '../dtos/case-type-response.dto';
import { CaseTypeDetailResponseDto } from '../dtos/case-type-detail-response.dto';
import { CaseTypeCategoryResponseDto } from '../dtos/case-type-category-response.dto';
import { CaseTypeDeletionImpactResponseDto } from '../dtos/case-type-deletion-impact-response.dto';

@Injectable({ providedIn: 'root' })
export class CaseTypeMapper {
  toDomain(dto: CaseTypeResponseDto): CaseTypeEntity {
    return {
      id: dto.id,
      name: dto.name,
      description: dto.description,
      categoryId: dto.categoryId,
      categoryName: dto.categoryName,
      isActive: dto.isActive,
      sortOrder: dto.sortOrder,
      checklistDisplayOnCases: dto.checklistDisplayOnCases,
      closedCaseVisibility: dto.closedCaseVisibility ?? ClosedCaseVisibility.OpenToEveryone,
      hasPublishedForm: dto.hasPublishedForm ?? false,
    };
  }

  toDomainArray(dtos: CaseTypeResponseDto[]): CaseTypeEntity[] {
    return dtos.map((dto) => this.toDomain(dto));
  }

  toDetailDomain(dto: CaseTypeDetailResponseDto): CaseTypeDetailEntity {
    return {
      ...this.toDomain(dto),
      createdOn: dto.createdOn,
      updatedOn: dto.updatedOn,
    };
  }

  toCategoryDomain(dto: CaseTypeCategoryResponseDto): CaseTypeCategoryEntity {
    return {
      id: dto.id,
      name: dto.name,
    };
  }

  toCategoryDomainArray(dtos: CaseTypeCategoryResponseDto[]): CaseTypeCategoryEntity[] {
    return dtos.map((dto) => this.toCategoryDomain(dto));
  }

  toDeletionImpactDomain(dto: CaseTypeDeletionImpactResponseDto): CaseTypeDeletionImpactEntity {
    const entity = new CaseTypeDeletionImpactEntity();
    entity.activeCasesCount = dto.activeCasesCount;
    entity.linkedCases = dto.linkedCases.map((c) => {
      const linkedCase = new LinkedCaseEntity();
      linkedCase.id = c.id;
      linkedCase.name = c.name;
      return linkedCase;
    });
    entity.linkedCaseForms = dto.linkedCaseForms.map((cf) => {
      const linkedForm = new LinkedCaseFormEntity();
      linkedForm.id = cf.id;
      linkedForm.name = cf.name;
      return linkedForm;
    });
    entity.linkedEmailTemplates = dto.linkedEmailTemplates.map((et) => {
      const linkedTemplate = new LinkedEmailTemplateEntity();
      linkedTemplate.id = et.id;
      linkedTemplate.name = et.name;
      return linkedTemplate;
    });
    entity.linkedProcessChecklists = dto.linkedProcessChecklists.map((pc) => {
      const linkedChecklist = new LinkedProcessChecklistEntity();
      linkedChecklist.id = pc.id;
      linkedChecklist.name = pc.name;
      return linkedChecklist;
    });
    entity.hasDependencies = dto.hasDependencies;
    return entity;
  }
}
